import '../lib/i18n'

export function I18nProvider({ children }: { children: React.ReactNode }) {
  // Since translations are bundled and i18n is initialized synchronously,
  // we don't need any loading state - just render children immediately
  return <>{children}</>
}
